import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import useNetwork from '../useNetwork';
import { AuctionTile } from './auction/AuctionTile';
import { AppDataContext } from "./AppDataContext";
import LoginAndRegistration from "./LoginAndRegistration";
import { Modal } from 'bootstrap';
import { captchaKey } from '../helpers';
import { toast } from 'react-toastify';
import { Helmet } from "react-helmet";

export function Home(props) {
    const context = useContext(AppDataContext);

    const { loading, networkError, netRequest, netRenderError } = useNetwork(true);

    const [auctions, setAuctions] = useState(null);
    const startIx = useRef(0);
    const pageSize = 8;


    const getAuctions = (startAt) => {

        const fetchAuctions = async (startingAt) => {
            const url = 'api/site/getauctions/' + startingAt + "/" + pageSize;
            console.log(url);
            const response = await netRequest(url);

            if (response.data != null) {
                setAuctions(response.data.auctionSessions);
            }
        };

        const startingAt = !isNaN(startAt) ? startAt : startIx.current;

        fetchAuctions(startingAt);

    };

    useEffect(() => {
        getAuctions(0);
        tick();

        return () => {
            // remove timer
            if (timer.current) {
                console.log('clearing timer');
                clearTimeout(timer.current);
            }
        };

    }, []);

    const timer = useRef(null);

    const tick = () => {
        // set up timer
        timer.current = setTimeout(() => {
            getAuctions(0);
            tick();
        }, 60000);
    }

    const handleJoinhKeyPress = (evt) => {
        if (evt.key === 'Enter') {
            handleJoinClicked();
        }
    }

    const handleJoinClicked = () => {
        var myModal = new Modal("#joinModal", {});
        myModal.show();
    }

    const [emailValue, setEmailValue] = useState('');
    const updateEmailValue = (evt) => { setEmailValue(evt.target.value); };

    const [listEmailValue, setListEmailValue] = useState('');
    const updateListEmailValue = (evt) => { setListEmailValue(evt.target.value); };
    const [formWasValidated, setFormWasValidated] = useState(false);

    const onSubmitSubscribe = async (event) => {
        event.preventDefault();
        await subscribeToList();
    }
    const subscribeToList = async () => {
        setFormWasValidated(true);
        const url = 'api/site/SubscribeWebsiteMailingList';

    

        if (listEmailValue.trim() != '') {

            window.grecaptcha.ready(function () {
                window.grecaptcha.execute(captchaKey(), { action: 'list_subscribe' }).then(async function (token) {
                    // Add your logic to submit to your backend server here.

                    //console.log(token);

                    const postData = {
                        email: listEmailValue.trim(),
                        captchaToken:token
                    };

                    const resp = await netRequest(url, postData);

                    if (resp.isError) {
                        toast.error('An error occurred.  Please try again.  If this continues, close and reopen your browser. (code: ' + resp.status + ')', {                                                                               
                            autoClose:10000
                        });

                    } else {
                        // clear the input fields before continuing
                        setListEmailValue('');
                        setFormWasValidated(false);

                        toast.success('Thank you, you have subscribed!', {  
                           
                        });


                    }
                });
            });
        }
    }

    return (
        <>

            <Helmet>
                <title>Local Estate Auctions on Bid Next Door</title>
                <meta name="description" content="Carefully selected local artwork, furniture, collectibles, tools, household items, and more!" />
                <meta property="og:title" content="Local Estate Auctions on Bid Next Door" />
                <meta property="og:image" content="https://www.bidnextdoor.com/images/bnd-logo@2x.png" />
                <meta property="og:url" content="https://www.bidnextdoor.com/" />
                <meta property="og:image:width" content="301" />
                <meta property="og:image:height" content="120" />
            </Helmet>

            <main class="content-page-home">

                <>
                    {!context.isLoggedIn &&
                        <div class="modal fade" id="joinModal" tabindex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <img src="images/bnd-logo@2x.png" height="" title="Bid Next Door" alt="Bid Next Door Logo" />
                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <LoginAndRegistration
                                            showLogin={false}
                                            showSignup={true}
                                            showBackToLogin={false}
                                            registrationComplete={false}
                                            initialUserName={emailValue}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    }
                    <section class="position-relative hero-header" style={{ background: 'url("images/top-banner.jpg")', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center' }}>
                        <div class="container d-flex justify-content-center h-100">
                            <div class="align-self-center position-relative hero-header__intro">
                                <h1 class="text-center">Find <strong>TREASURES</strong></h1>
                                <h2 class="text-center">in <strong>YOUR</strong> Neighborhood</h2>
                                {!context.isLoggedIn && <div class="join my-2 mx-auto">
                                    <div class="input-group flex-nowrap">
                                        <input class="form-control d-inline" type="text" placeholder="Enter your email" aria-label="Enter your email"
                                            onKeyDown={evt => handleJoinhKeyPress(evt)}
                                            onChange={evt => updateEmailValue(evt)}
                                        />
                                        <button class="btn btn-fill btn-secondary d-inline ms-3" type="button" onClick={handleJoinClicked}>JOIN</button>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </section>
                </>

                {false &&
                    <section>
                        <div class="container py-5">
                            <h2 class="text-center position-relative location-search">
                                Auctions Around <span class="geo-location">New York, NY 10025</span>
                                <div class="divider"></div>
                                <div class="location-search__div">
                                    <form action="search.html" method="post" class="form-inline my-2 mx-auto my-lg-0 search">
                                        <div class="input-group flex-nowrap">
                                            <span class="input-group-text">
                                                <i class="bi bi-search"></i>
                                            </span>
                                            <input class="form-control" type="search" placeholder="Search" aria-label="Search" />
                                        </div>
                                    </form>
                                </div>
                            </h2>
                            <div class="d-block map">
                                <img src="images/group 297@2x.png" title="map placeholder" alt="map placeholder" width="100%" />
                                <a href="#" class="btn btn-secondary my-3 mx-auto" title="View All">View All</a>
                            </div>

                        </div>
                    </section>
                }
                <section class="background-primary">
                    <div class="container py-5">
                        {auctions?.length == 0 &&
                            <div class="row">
                                <div class="col">
                                    <h2 class="text-center mb-3">We're currently working on our <strong>NEW</strong> catalog of upcoming <strong>AUCTIONS</strong></h2>

                                </div>
                            </div>
                        }
                        <div class="row">
                            {
                                auctions?.map((a) => <AuctionTile key={a.secureId} auction={a} />)
                            }
                        </div>

                    </div>
                </section>


            </main>
            <section class="container-fluid">
                <div class="row newsletter p-0">
                    <div class="col newsletter--image" style={{ background: "url('images/top-banner-vector.png')", backgroundRepeat: "no-repeat", backgroundSize: "contain", backgroundPosition: "center center" }}>

                    </div>
                    <div class="col newsletter--content">
                        <div class="mx-auto py-3 px-3 py-md-4 px-md-5 newsletter--content__div">
                         
                            <form class="g-3 mb-3" onSubmit={onSubmitSubscribe}>
                                <div class="  ">

                                    <h2 class="text-center mb-3">Get <strong>NOTIFIED</strong> about new and upcoming <strong>AUCTIONS</strong></h2>
                                    <div class="join my-2 mx-auto">
                                        <div class="input-group flex-nowrap">
                                            <input class="form-control d-inline" type="email" placeholder="Enter your email" aria-label="Enter your email" required
                                                onChange={updateListEmailValue}
                                                value={listEmailValue}
                                                maxLength="100"
                                                pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                                            />
                                            <button type="submit" class="btn btn-fill btn-secondary d-inline ms-3">SUBSCRIBE</button>
                                            
                                        </div>                                      
                                    </div>
                                </div>

                            </form>

                            <h4 class="text-center with-underline">Follow Us</h4>
                            <div class="d-flex justify-content-center social">
                                <a target="_blank" href="https://www.facebook.com/bidnextdoor" title="Facebook" class="px-3 mb-2">
                                    <i class="bi bi-facebook"></i>
                                </a>
                                <a target="_blank" href="https://www.instagram.com/bidnextdoor/" title="Instagram" class="px-3 mb-2">
                                    <i class="bi bi-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    );
}
